import { render, staticRenderFns } from "./admin-layout.vue?vue&type=template&id=1a3e7e00&scoped=true&"
import script from "./admin-layout.vue?vue&type=script&lang=js&"
export * from "./admin-layout.vue?vue&type=script&lang=js&"
import style0 from "./admin-layout.vue?vue&type=style&index=0&id=1a3e7e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3e7e00",
  null
  
)

export default component.exports